import React, { useRef, useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import moment from 'moment';
import axios from 'axios';

import { cmes } from '../../util/varios';
import { Mensaje, MensajeSiNo } from '../mensajes2';
import { Dimmer } from '../spinner';

import {
    formatMoneda, validaMonto, formatoMonto, seleccionarCampo
} from '../../util/varios';

const AgregarValorPetro = (props) => {

    const fechasistema = JSON.parse(localStorage.getItem('fechasistema'))

    const [clase, setClase] = useState('d-flex bluex-bg');
    const btnCancela = useRef();
    const btnAcepta = useRef();
    const txtAnio = useRef();
    const txtFechaApli = useRef();
    const txtHoraApli = useRef(); // Nuevo ref para la hora
    const cmbMes = useRef();
    const txtValor = useRef();
    const [idconsejo, setIdConsejo] = useState(0)
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [mes, setMes] = useState(1)
    const [activate, setActivate] = useState(false);
    const [values, setValues] = useState()

    const [url, setUrl] = useState('');

    let op = require('../../../src/modulos/datos');
    let token = localStorage.getItem('jwtToken');

    const [operacion, setOperacion] = useState(0);

    useEffect(() => {
        let obj = JSON.parse(localStorage.getItem('post'));
    }, [props.operacion]);

    const blanquear = () => {
        txtValor.current.value = ''
    }

    const cancelar = () => {
        blanquear();
        props.onHideCancela();
    }

    const handleInputMontoChange = (event) => {
        validaMonto(event);
        if (event.target.value === '' || parseFloat(event.target.value.trim().replace(/\./g, "").replace(",", ".")) === 0.00) {
            event.target.value = '0,00'
        }
        if (event.which >= 37 && event.which <= 40) {
            event.preventDefault();
        }

        // Devuelve el número formateado
        let e = event.target.value.replace(/\D/g, "")
            .replace(/([0-9])([0-9]{2})$/, '$1.$2')
            .replace(/\B(?=(\d{3})+(?!\d)\.?)/g, ",");

        return formatMoneda(e)
    };

    const procesarRegistro = () => {
        // Obtener fecha y hora por separado y unirlos
        const fecha = txtFechaApli.current.value;
        const hora = txtHoraApli.current.value;
        
        // Validar que ambos campos estén completos
        if (!fecha || !hora) {
            setMensaje({ mostrar: true, titulo: 'Error', texto: 'Debe completar tanto la fecha como la hora', icono: 'error' });
            return;
        }
        
        const fechaF = `${fecha} ${hora}`;

        let endpoint = `${op.conexion}/api/configuracion/actualizarvalorcambio`;

        let body = {
            operacion: 1,
            fechasistem: fechasistema,
            fecha: fechaF,
            valor: txtValor.current.value.replace(",", ".")
        }

        axios.post(endpoint, body, {
           headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'
        },
        }).then(function (response) {
            if (response.status === 200) {
                setActivate(false);
                setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'Operacion Realizada.', icono: 'exito' });
                localStorage.setItem("factorCambio", JSON.stringify({
                    fecha: fechasistema,
                    valor: txtValor.current.value.replace(",", ".")
                }));

            }
        }).catch(function (error) {
            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
            setActivate(false);
        })
    }

    const onChangeValidar = (e) => {
        e.preventDefault();

        let sigue = true;

        if (txtValor.current.value === '') {
            setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe de Ingresar el Valor', icono: 'informacion' });
            sigue = false;
            txtValor.current.focus();
        }

        if (!txtFechaApli.current.value) {
            setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe de Ingresar la Fecha', icono: 'informacion' });
            sigue = false;
            txtFechaApli.current.focus();
        }

        if (!txtHoraApli.current.value) {
            setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe de Ingresar la Hora', icono: 'informacion' });
            sigue = false;
            txtHoraApli.current.focus();
        }

        if (sigue) {
            procesarRegistro();
        }
    };

    const handleCloseSi = () => {
        setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
        procesarRegistro();
    };

    const cerrarModal = () => {
        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
        props.onHideCancela();
        props.renderizar();
    }

    return (
        <Modal
            {...props}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
            backdrop="static"
            keyboard={false}
            onShow={() => {
                setOperacion(props.operacion);

                if (props.operacion !== 1) {
                    console.log(props.unidad)
                    setMes(props.unidad ? props.unidad.mes : props.unidad.mes)
                    setValues(props.unidad)
                    
                    // Separar fecha y hora si ya existe un valor
                    if (props.unidad && props.unidad.fechaaplic) {
                        const fechaHora = moment.utc(props.unidad.fechaaplic);
                        txtFechaApli.current.value = fechaHora.format('YYYY-MM-DD');
                        txtHoraApli.current.value = fechaHora.format('HH:mm');
                    }
                } else {
                    // Establecer valores por defecto para nueva entrada
                    txtFechaApli.current.value = moment.utc(JSON.parse(localStorage.getItem('fechasistema'))).format('YYYY-MM-DD');
                    txtHoraApli.current.value = moment.utc().format('HH:mm');
                }
            }}
        >
            <Modal.Header className='azulGradiant'>
                <div className='fw-bold text-light'><h3>{operacion === 1 ? 'Agregar Factor Valor de Cambio' : operacion === 2 ? 'Modificar Factor Valor de Cambio' : operacion === 3 ? 'Eliminar Factor Valor de Cambio' : 'Consultar Factor Valor de Cambio'}</h3></div>
                <button className="bg-transparent" style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }} onClick={cancelar}>
                    <i className="far fa-window-close"></i>
                </button>
            </Modal.Header>
            <Modal.Body style={{ maxHeight: '70vh', overflow: 'scroll' }}>
                <Mensaje mensaje={mensaje}
                    onHide={() => {
                        mensaje.titulo === 'Exito.' ?
                            cerrarModal() :
                            setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
                    }
                    } />
                <MensajeSiNo mensaje={mensajesino}
                    onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })} onHideSi={handleCloseSi} />
              <Dimmer active={activate} inverted>
              </Dimmer>
                <div className='row col-md-12 px-0 mx-auto'>
                    <div className="input-group mb-2 input-group-sm col-sm-7">
                        <label className="input-group-text" id="inputGroup-sizing-sm">Fecha Aplicación:</label>
                        <input type="date" ref={txtFechaApli} disabled={operacion === 3 || operacion === 4 ? true : false} className="form-control text-uppercase" autoComplete='off' aria-label="Fecha de aplicación" aria-describedby="inputGroup-sizing-sm" />
                    </div>

                    <div className="input-group mb-2 input-group-sm col-sm-5">
                        <label className="input-group-text" id="inputGroup-sizing-sm">Hora:</label>
                        <input type="time" ref={txtHoraApli} disabled={operacion === 3 || operacion === 4 ? true : false} className="form-control text-uppercase" autoComplete='off' aria-label="Hora de aplicación" aria-describedby="inputGroup-sizing-sm" step="60" />
                    </div>
                    <div className="input-group mb-2 input-group-sm col-sm-7"></div>

                    <div className="input-group mb-2 input-group-sm col-sm-5">
                        <label className="input-group-text " id="inputGroup-sizing-sm">Valor:</label>
                        <input type="text" placeholder='0,00' onFocus={seleccionarCampo} disabled={operacion === 3 || operacion === 4 ? true : false} ref={txtValor} defaultValue={props.unidad ? formatMoneda(props.unidad.valor.toString().replace('.', ','), ',', '.', 2) : ''} className="form-control text-right" autoComplete='off' aria-label="Valor" aria-describedby="inputGroup-sizing-sm" onKeyUp={handleInputMontoChange} />
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <div className='col-sm-12 d-flex justify-content-center row mx-auto py-1'>
                    <button type="button" ref={btnAcepta} onClick={onChangeValidar} className="col-sm-6 btn-sm btn btn-success rounded-pill"><i className="far fa-check-circle"></i>Aceptar</button>
                    <button type="button" ref={btnCancela} onClick={cancelar} className="col-sm-6 btn-sm btn btn-danger rounded-pill"><i className="fas fa-window-close"></i>Cancelar</button>
                </div>
            </Modal.Footer>
        </Modal>
    );
}
export default AgregarValorPetro;